<template>
  <div class="d-timetal__container" :class="{'d-timetal__container__width': !isShowSubjects}">
    <div class="d-guides">
      <StilGuides :video-id="videoGuideId"
                  :textForLink="videoGuideText"></StilGuides>
      <p class="italic" v-if="isShowSubjects"><b>Bemærk:</b> Opret, slet eller redigere fag påvirker kun
        indberetningsdata'en - ikke i resten af Docendo</p>
    </div>
    <table class="d-table" :class="{'d-table__subjects': isShowSubjects}">
      <thead v-if="!isShowSubjects">
      <tr class="tr--one">
        <th>Klasse</th>
        <th>Klassetrin</th>
        <th>Spor</th>
        <th>
          <div class="th__title-and-button">
            Klassetype
          <button @click="setIsModalCreateGrade">Opret klasse</button>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <template v-for="klasse in klasserMedProps">
        <tr class="tr--one pos-relative">
          <td class="grade-name">
            <div class="hint--top-right d-hidden__dropdown" v-if="!isShowSubjects"
                 aria-label="Slet klasse og fag fra indberetningen">
              <button class="icon__bg-circle icon__bg-circle--danger"
                      @click="setTheDeleteGrade(klasse)">
                <span class="icon-bin"></span>
              </button>
            </div>
            {{ klasse.klassebetegnelse }}
            <button class="klasse__create__btn"
                    v-if="isShowSubjects"
                    @click="theCreateSubject = klasse">
              Opret fag
            </button>
          </td>
          <td>
            <select
              v-if="!isShowSubjects"
              class="d-select__small"
              :value="klasse.klassetrin"
              @change="updateStilKlasse(klasse, 'klassetrin', $event.target.value)">
              <option
                v-for="standardKlasse in klassetrin"
                :key="standardKlasse">
                {{ standardKlasse }}
              </option>
            </select>
          </td>
          <td>
            <input
              v-if="!isShowSubjects"
              class="d-input__small"
              type="text"
              maxlength="10"
              :value="klasse.spor"
              @input="checkSporMaxLength($event)"
              @blur="updateStilKlasse(klasse, 'spor', $event.target.value, $event.target)">
          </td>
          <td>
            <select
              v-if="!isShowSubjects"
              class="d-select__small"
              :value="klasse.klasse_type"
              @change="updateStilKlasse(klasse, 'klasse_type', $event.target.value)">
              <option
                v-for="(klasseType, key) in klasseTyper"
                :key="key"
                :value="key">
                {{ klasseType }}
              </option>
            </select>
          </td>
        </tr>
        <template v-if="isShowSubjects">
          <tr class="tr__header">
            <td>Fag</td>
            <td>Fagkode</td>
            <td>Klassetimer</td>
            <td>Underviser(e)</td>
          </tr>
          <tr v-for="fag in klasse.fag" class="tr__two" :key="fag.fag_id">
            <td>
              <div class="hint--top-right fag-delete-bin"
                   aria-label="Slet fra indberetningen">
                <button class="icon__bg-circle icon__bg-circle--danger"
                        @click="setTheDeleteSubject(klasse, fag)">
                  <span class="icon-bin"></span>
                </button>
              </div>
              {{ fag.fag_navn }}
            </td>
            <td>
              <select
                @change="updateStilKlasseFag(klasse, fag, 'fagkode', $event.target.value)"
                :value="fag.fagkode" class="d-select__small">
                <option
                  v-for="fag in standardSubjects"
                  :value="fag.fagkode">
                  {{ fag.fagkode }}: {{ fag.name }}
                </option>
              </select>
            </td>
            <td>
              <input type="text"
                     class="d-input__small"
                     @focus="$event.target.select()"
                     @keyup.enter="updateStilKlasseFag (klasse, fag, 'klokketimer', $event.target.value, $event.target)"
                     @blur="updateStilKlasseFag (klasse, fag, 'klokketimer', $event.target.value, $event.target)"
                     :value="fag.klokketimer">
            </td>
            <td>
              <div style="width: 400px;" @click="theEditTeacher = fag.fag_id">
                <DSelect
                  v-if="fag.v_is_the_edit_teacher"
                  :items="users"
                  :itemsSelected="fag.laerere"
                  :usersSSNHash="usersSSNHash"
                  @update="updateStilKlasseFag (klasse, fag, 'laerere', $event)"
                  @close="theEditTeacher = null">
                </DSelect>
                <ul v-else
                    class="d-select__container"
                    :class="{'d-select__container--empty': fag.laerere.length < 1}">
                  <li class="d-select__container__add"
                      v-if="fag.laerere.length < 1">
                    Tilføj minimun en underviser
                  </li>
                  <li class="d-pill"
                      v-for="user in fag.laerere"
                      :class="{'d-pill--error': user.v_no_cpr}">
                    {{ user.v_name }}
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </template>
      </template>
      </tbody>
    </table>
    <ModalConfirmation
      v-if="theDeleteSubject || theDeleteGrade"
      @close="closeModalConfirm"
      @confirm="confirmDelete"
      propLocale="da"
      :showClose="false">
    </ModalConfirmation>
    <KompetenceIndberetningKlasserFagForm
      v-if="theCreateSubject"
      :theCreateSubject="theCreateSubject"
      :standardSubjects="standardSubjects"
      @save="saveNewSubject"
      @close="theCreateSubject = null">
    </KompetenceIndberetningKlasserFagForm>
    <KompetenceIndberetningCreateKlasseModal
      v-if="isModalCreateGrade"
      @save="saveNewGrade"
      @close="setIsModalCreateGrade">
    </KompetenceIndberetningCreateKlasseModal>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import DModal from '../../common/DModal'
import DSelect from './KompetenceIndberetningKlasserDSelect'
import KompetenceIndberetningKlasserFagForm from './KompetenceIndberetningKlasserFagForm'
import eventbus from '../../../eventbus'
import ModalConfirmation from '../../Modals/ModalConfirmation'
import StilGuides from './../StilGuides'
import KompetenceIndberetningCreateKlasseModal from './KompetenceIndberetningCreateKlasseModal.vue'

export default {
  components: {
    KompetenceIndberetningCreateKlasseModal,
    ModalConfirmation, KompetenceIndberetningKlasserFagForm, DSelect, DModal, StilGuides},
  mixins: [clickaway],
  props: {
    standardSubjects: {
      type: Array,
      default: () => []
    },
    dbStilData: {
      type: Object,
      default: () => {
      }
    },
    stilData: {
      type: Object,
      default: () => {
      }
    },
    isShowSubjects: {
      type: Boolean,
      default: false
    },
    usersSSNHash: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      isModalCreateGrade: false,
      theEditTeacher: null,
      klassetrin: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      theCreateSubject: null,
      theDeleteSubject: null,
      klasseTyper: {
        40: 'Normalklasser - fuldt årgangsdelte',
        41: 'Normalklasser - Ikke fuldt årgangsdelte',
        45: 'EUD10',
        46: '20/20',
        50: 'Specialklasser',
        55: 'Klasser for ældre tosprogede elever'
      },
      formErrors: {},
      theDeleteGrade: null
    }
  },
  computed: {
    videoGuideId () {
      return !this.isShowSubjects ? '5Id4TeuHMvI?start=122' : '5Id4TeuHMvI?start=139'
    },
    videoGuideText () {
      return !this.isShowSubjects ? 'Guide: Se videoguide til udfyldning af klasser' : 'Guide: Se videoguide til udfyldning af fag'
    },
    schoolId () {
      return this.$route.params.school_id
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    klasser () {
      if (!this.stilData['klasser']) {
        return []
      }
      return this.stilData['klasser']
    },
    klasserMedProps () {
      const klasser = this.klasser.map(klasse => {
        klasse.fag.forEach(fag => {
          this.$set(fag, 'v_klasse_name', klasse.klassebetegnelse)
          const isTheEditTeacher = this.theEditTeacher === fag.fag_id
          this.$set(fag, 'v_is_the_edit_teacher', isTheEditTeacher)
          fag.laerere.forEach(laerer => {
            let teacherName = laerer.user_name + ' (Mangler CPR)'
            const user = this.usersSSNHash[laerer.cpr]
            if (user) {
              teacherName = this.usersSSNHash[laerer.cpr].name
              this.$delete(laerer, 'v_no_cpr')
            } else {
              this.$set(laerer, 'v_no_cpr', true)
            }
            this.$set(laerer, 'v_name', teacherName)
          })
        })
        klasse.fag = klasse.fag.sort((a, b) => {
          return a.fag_navn.localeCompare(b.fag_navn, 'da', {
            numeric: true,
            sensitivity: 'base'
          })
        })
        return klasse
      })
      return klasser.sort((a, b) => {
        return a.klassebetegnelse.localeCompare(b.klassebetegnelse, 'da', {
          numeric: true,
          sensitivity: 'base'
        })
      })
    },
    standardSubjectsHash () {
      return this.$helpers.hashMap(this.standardSubjects, 'fagkode')
    }
  },
  methods: {
    checkSporMaxLength (event) {
      if (event.target.value.length >= 10) {
        eventbus.toast = {text: 'Spor kan maks være 10 tegn', success: false}
      }
    },
    saveNewGrade (newKlasse) {
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      report.klasser.push(newKlasse)
      this.$emit('updateStil', report)
      this.setIsModalCreateGrade(false)
    },
    setIsModalCreateGrade (bool) {
      if (bool) {
        this.isModalCreateGrade = bool
        return
      }
      if (this.isModalCreateGrade) {
        this.isModalCreateGrade = false
      } else {
        this.isModalCreateGrade = true
      }
    },
    closeModalConfirm () {
      this.theDeleteSubject = null
      this.theDeleteGrade = null
    },
    setTheDeleteGrade (klasse) {
      this.theDeleteGrade = klasse
    },
    setTheDeleteSubject (klasse, fag) {
      this.theDeleteSubject = {klasse, fag}
    },
    confirmDeleteGrade () {
      const klasseId = this.theDeleteGrade.klasse_id
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      const klasseIdx = report.klasser.findIndex(klasse => klasse.klasse_id === klasseId)
      if (klasseIdx < 0) {
        return
      }
      report.klasser.splice(klasseIdx, 1)
      this.$emit('updateStil', report)
      this.theDeleteGrade = null
    },
    confirmDelete () {
      if (this.theDeleteGrade) {
        this.confirmDeleteGrade()
        return
      }
      const klasseId = this.theDeleteSubject.klasse.klasse_id
      const fagId = this.theDeleteSubject.fag.fag_id
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      const klasseIdx = report.klasser.findIndex(klasse => klasse.klasse_id === klasseId)
      const fagIdx = report.klasser[klasseIdx].fag.findIndex(fag => fag.fag_id === fagId)
      if (klasseIdx < 0 || fagIdx < 0) {
        return
      }
      report.klasser[klasseIdx].fag.splice(fagIdx, 1)
      this.$emit('updateStil', report)
      this.theDeleteSubject = null
    },
    updateStilKlasse (itemKlasse, prop, val) {
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      const idx = report.klasser.findIndex(klasse => klasse.klasse_id === itemKlasse.klasse_id)
      if (idx > -1) {
        if (report.klasser[idx][prop] === val) {
          return
        }
        report.klasser[idx][prop] = val
      }
      this.$emit('updateStil', report)
    },
    isValidNumber (input) {
      if (isNaN(input)) {
        return false
      }
      if (input < 0) {
        return false
      }
      return true
    },
    updateStilKlasseFag (itemKlasse, itemFag, prop, val, target) {
      if (prop === 'klokketimer') {
        if (target) {
          target.classList.remove('d-input__small--warning')
        }
        if (!Number.isInteger(Number(val))) {
          window.alert('Klassetimer skal være et helt tal')
          target.classList.add('d-input__small--warning')
          return
        }
      }
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      const klasseIdx = report.klasser.findIndex(klasse => klasse.klasse_id === itemKlasse.klasse_id)
      const fagIdx = report.klasser[klasseIdx].fag.findIndex(fag => fag.fag_id === itemFag.fag_id)
      // Teachers
      if (prop === 'laerere') {
        let currentUsers = report.klasser[klasseIdx]['fag'][fagIdx][prop]
        let hours = report.klasser[klasseIdx]['fag'][fagIdx]['klokketimer']
        val = val.map(user => {
          // hvis de allerede har fået redigeret timer skal de beholde de timer
          const userIdx = currentUsers.findIndex(currentUser => currentUser.cpr === user.ssn)
          if (userIdx > -1 && currentUsers[userIdx]['klokketimer']) {
            hours = currentUsers[userIdx]['klokketimer']
          }
          return {
            cpr: user.ssn,
            klokketimer: hours,
            klokketimer_type: '1',
            user_id: user.id,
            user_name: user.name
          }
        })
      }
      // Klokketimer
      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
        target.value = report.klasser[klasseIdx]['fag'][fagIdx][prop]
        eventbus.toast = {text: 'Skal være 0 eller større', success: false}
        return
      }
      if (fagIdx > -1 || klasseIdx > -1) {
        if (report.klasser[klasseIdx]['fag'][fagIdx][prop] === val) {
          return
        }
        report.klasser[klasseIdx]['fag'][fagIdx][prop] = val
      }
      this.$emit('updateStil', report)
    },
    saveNewSubject (newSubject) {
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      const klasseIdx = report.klasser.findIndex(klasse => klasse.klasse_id === newSubject.klasse_id)
      report.klasser[klasseIdx].fag.push(newSubject)
      this.$emit('updateStil', report)
    },
    setTheEditSubject (subject) {
      this.theEditSubject = subject
    },
    close () {
      this.theEditSubject = null
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";


.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  max-width: 1200px;
  border-radius: 4px;
}

.d-timetal__container.d-timetal__container__width {
  width: initial;
}

.d-table {
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table.d-table__subjects tbody tr.tr--one {
  border-bottom: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
  background: #f6f9fc;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table tbody tr.tr__header {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: #728195;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table tbody tr {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

input[type="number"] {
  max-width: 65px;
  padding: 0.5rem 0.75rem;
  text-align: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

select,
input[type="text"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 100px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
}

.d-table input[type="text"] {
  width: 100% !important;
}

.d-table tbody tr.tr--one {
  background: #fbfbfb;
  position: relative;
}

.d-table:not(.d-table__subjects) tbody tr.tr--one:nth-child(odd) {
  background: #fff;
}

.d-table:not(.d-table__subjects) tbody tr:hover {
  background: aliceblue !important;
}

.d-table tbody tr.tr__two:nth-child(odd) {
  background: #fbfbfb;
}

.d-table tbody tr.tr__header td {
  padding: 0rem 1rem;
}

.grade-name {
  font-weight: bold;
  min-width: 220px;
  display: flex;
  align-items: center;
}

.d-table:not(.d-table__subjects) .grade-name {
  padding-left: 0 !important;
}

.d-hidden__dropdown {
  opacity: 0;
  margin-left: -1rem;
  transition: margin-left 0.25s, opacity 0.25s;
}

.d-table:not(.d-table__subjects) tr:hover .grade-name .d-hidden__dropdown,
.tr--one--active .d-hidden__dropdown {
  opacity: 1;
  margin-left: 0;
}


.d-select__small,
.d-input__small {
  height: 28px !important;
}

.d-input__small {
  width: 65px !important;
  min-width: 65px !important;
  text-align: center;
}

.d-input__small.d-input__small--warning {
  border: 1px solid red!important;
}

.d-table tbody tr.tr__two:hover {
  background: aliceblue;
}

.fag-delete-bin {
  opacity: 0;
  transform: scale(0.85);
  transition: 0.15s;
  pointer-events: none;
}

.d-table tbody tr.tr__two:hover .fag-delete-bin,
.grade-name:hover .fag-delete-bin {
  opacity: 1;
  transform: scale(1);
  pointer-events: auto;
}

.d-table tbody tr.tr__two td {
  padding: 0.25rem 0.5rem;
}

.d-table tbody tr.tr__two td:first-child {
  font-weight: bold;
  padding-left: 0;
  width: 100% !important;
}

.d-table tbody tr.tr__header td:first-child {
  padding-left: 2rem;
}

.d-select__container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  flex-wrap: wrap;
  padding: 0.25rem 0.5rem;
  border: 1px dashed #ccc;
  border-radius: 4px;
}

.d-select__container.d-select__container--empty {
  padding: 0;
}

.d-select__container:hover {
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.d-select__container__add {
  cursor: pointer;
  border-radius: 4px;
  color: #888888;
  width: 100%;
  background: #ffffff;
  padding: 0.25rem 0.5rem;
}

.d-select__container:hover .d-select__container__add {
  color: var(--purple);
}

.d-pill {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  font-size: 1rem;
  color: #222222;
  display: inline-block;
  border-radius: 4px;
  padding: 4px 8px;
  line-height: 1rem;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.d-pill.d-pill--error {
  background: #e96f72;
  font-size: 10px;
}

.klasse__create__btn {
  position: absolute;
  top: 0.25rem;
  right: 1rem;
}

.klasse__create__btn:hover {
  color: #222222;
}

.d-guides {
  border: 1px solid rgba(204, 204, 204, 0.75);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.th__title-and-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// KompetenceIndberetningKlasser.vue?0ff5e7c6